<div class="splash d-flex justify-center bg-white dark:bg-neutral-950">
    <div class="max-w-[350px] m-auto">
        <div class="flex items-center gap-x-1 animated pulse infinite">
            <img class="inline-block" src="https://votevpss.figma.site/_assets/v11/890c78de0fa8a8b81f5b9b73c200585c89cf0f43.png" alt="iyconsft logo">
            <!-- <div class="grow">
                <a class="relative flex-none font-bold text-4xl text-neutral-600 focus:outline-hidden dark:text-neutral-700/90" aria-label="Brand">
                   Iyconsoft <span class="bg-clip-text bg-linear-to-tr from-blue-400 to-blue-900 text-transparent dark:to-blue-900">Solutions</span>
                </a>
            </div> -->
        </div>
    </div>
</div>

